// extracted by mini-css-extract-plugin
export default {"error":"Error_error__Ka8mk","disabled":"Error_disabled__xJj6n"};